export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-results-0b51786e9bfd685a4c278c2d1f451314.svg";